import moment from 'moment';
import React from 'react';

const DateFormatter = ({ dateTime, className = '' }) => {
  return (
    <div className={`info ${className}`}>
      <h4 className="f-12 fw-medium mb-1 text-dark">
        {moment(dateTime).format('D MMM, YYYY')}
      </h4>
      <p className="mb-0 f-12 font-manrope text-active">
        {moment(dateTime).format('hh:mm A')}
      </p>
    </div>
  );
};

export default DateFormatter;
